import { reqNoAuth } from '../../@api/request';

export default class NPLStatsService {
  static nplRank = async (
    type: string,
    court: string,
    region: string,
    usage: string,
    bank: string,
    start: string,
    end: string,
    limit: number,
  ) => {
    const result = await reqNoAuth.get(
      `/stat/npl/rank?type=${type}&court=${court}&region=${region}&usage=${usage}&bank=${bank}&start=${start}&end=${end}&limit=${limit}`,
    );
    return result.data;
  };

  static weeklyTrend = async (
    court: string,
    region: string,
    usage: string,
    bank: string,
    date: string,
  ) => {
    const result = await reqNoAuth.get(
      `/stat/npl/weekly-trend?court=${court}&region=${region}&usage=${usage}&bank=${bank}&date=${date}`,
    );
    return result.data;
  };

  static usageOverview = async (
    court: string,
    region: string,
    usage: string,
    bank: string,
    start: string,
    end: string,
    is_detail: boolean,
  ) => {
    const result = await reqNoAuth.get(
      `/stat/npl/usage?court=${court}&region=${region}&usage=${usage}&bank=${bank}&start=${start}&end=${end}&is_detail=${is_detail}`,
    );
    return result.data;
  };

  static regionalOverview = async (
    court: string,
    region: string,
    usage: string,
    bank: string,
    start: string,
    end: string,
  ) => {
    const result = await reqNoAuth.get(
      `/stat/npl/region?court=${court}&region=${region}&usage=${usage}&bank=${bank}&start=${start}&end=${end}`,
    );
    return result.data;
  };

  static nplTrend = async (
    type: string,
    court: string,
    region: string,
    usage: string,
    bank: string,
    date: string,
  ) => {
    const result = await reqNoAuth.get(
      `/stat/npl/trend?type=${type}&court=${court}&region=${region}&usage=${usage}&bank=${bank}&date=${date}`,
    );
    return result.data;
  };

  static monthlyTrend = async (
    court: string,
    region: string,
    usage: string,
    bank: string,
    start: string,
    end: string,
  ) => {
    const result = await reqNoAuth.get(
      `/stat/npl/monthly-trend?court=${court}&region=${region}&usage=${usage}&bank=${bank}&start=${start}&end=${end}`,
    );
    return result.data;
  };
}
